import { Condition, ConditionNode } from '@sdbn/common-extended';
import { TransportColoringThemeAdministrationAPIService } from './../../../../api/transportvisualization/TransportColoringThemeAdministration.service';
import { TransportColoringRule } from './../../../../api/transportvisualization/transportvisualization.model';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DataSetDefinitionConverterService, DetailLayout, DetailLayoutItemProvider } from '@sdbn/common';

@Component({
  selector: 'yard-transport-visualization-rule',
  standalone: false,
  templateUrl: './transport-visualization-rule.component.html',
  styleUrl: './transport-visualization-rule.component.scss',
})
export class TransportVisualizationRuleComponent implements OnInit {

  condition = new Condition({ rootNode: new ConditionNode({ operator: 'AND' }) });

  detailLayout = new DetailLayout({ "sequences": [{ "allowFolding": false, "showTitle": false, "blocks": [{ "showTitle": false, "columnCount": 1, "rowCount": 3, "columnWidths": [100], "cells": [{ "column": 1, "row": 1, "colSpan": 1, "rowSpan": 1, "fields": [{ "id": "name", "key": "name", "reference": null, "width": 75 }, { "id": "iconCss", "key": "iconCss", "reference": null, "width": 25 }] }, { "column": 1, "row": 2, "colSpan": 1, "rowSpan": 1, "fields": [{ "id": "colorForegroundLight", "key": "colorForegroundLight", "width": 50 }, { "id": "colorBackgroundLight", "key": "colorBackgroundLight", "width": 50 }] }, { "column": 1, "row": 3, "colSpan": 1, "rowSpan": 1, "fields": [{ "id": "colorForegroundDark", "key": "colorForegroundDark", "width": 50 }, { "id": "colorBackgroundDark", "key": "colorBackgroundDark", "width": 50 }] }] }] }] });
  detailLayoutItemProvider: DetailLayoutItemProvider;
  attributes = [{ "id": "0894c2b1-9633-4aad-ab08-87a94f88855c", "key": "colorBackgroundDark", "type": "STRING", "precision1": 255, "precision2": null, "enumId": null, "lookupId": null }, { "id": "63f38d61-4c58-4e3f-ba86-db9d169d650c", "key": "colorForegroundDark", "type": "STRING", "precision1": 2255, "precision2": null, "enumId": null, "lookupId": null }, { "id": "7aecdbc3-2c5c-4a89-b42e-1170176ada10", "key": "colorBackgroundLight", "type": "STRING", "precision1": 255, "precision2": null, "enumId": null, "lookupId": null }, { "id": "9679e8d2-5e45-4c8f-a3f3-8d9d734de6fb", "key": "index", "type": "NUMBER", "precision1": 10, "precision2": 0, "enumId": null, "lookupId": null }, { "id": "a4265d10-0117-4bb3-8abc-1a39cb5975a9", "key": "name", "type": "STRING", "precision1": 255, "precision2": null, "enumId": null, "lookupId": null }, { "id": "a58b1b87-7930-4528-8b6a-800f90699cd2", "key": "iconCss", "type": "STRING", "precision1": 255, "precision2": null, "enumId": null, "lookupId": null }, { "id": "b5bbba66-162b-4cac-96cf-40fa39cc7050", "key": "condition", "type": "TEXT", "precision1": null, "precision2": null, "enumId": null, "lookupId": null }, { "id": "ba7d8d75-fb90-4bbd-91a6-1d922cb6123b", "key": "colorForegroundLight", "type": "STRING", "precision1": 255, "precision2": null, "enumId": null, "lookupId": null }];

  rule?: TransportColoringRule;

  @Input('rule') set setRule(value: TransportColoringRule) {
    this.rule = value;
    if (value.condition && value.condition != '') {
      this.condition = new Condition(JSON.parse(value.condition));
    } else {
      this.condition = new Condition({ rootNode: new ConditionNode({ operator: 'AND' }) });
    }
  }

  @Input() showDetails: boolean;

  @Output() deleteRule = new EventEmitter<TransportColoringRule>();

  @Output() editRule = new EventEmitter<TransportColoringRule>();

  constructor(
    private dataSetDefinitionConverterService: DataSetDefinitionConverterService
  ) {

  }

  ngOnInit(): void {
    this.detailLayoutItemProvider = this.dataSetDefinitionConverterService.createDetailLayoutItemProvider(this.attributes, 'common.processing.entity.process-step', false);
  }



}
